import { Settings as LayoutSettings } from '@ant-design/pro-layout';
import { IconFontUrl } from '../src/utils/icon/index';

const Settings: LayoutSettings & {
  pwa?: boolean;
  logo?: string;
} = {
  layout: 'mix',
  navTheme: 'light',
  headerTheme: 'light',
  fixSiderbar: true,
  menuHeaderRender: undefined,
  primaryColor: 'rgba(41, 97, 255, 1)',
  contentWidth: 'Fluid',
  fixedHeader: false,
  colorWeak: false,
  title: 'BlueGrowth Cloud',
  pwa: false,
  logo: 'https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg',
  iconfontUrl: IconFontUrl,
};

export default Settings;
